<div class="main-wrapper">
  <div class="container">
    <h3 class="heading text-center">{{section?.header}}</h3>
    <div class="divider"></div>
    <div class="row content-wrapper">
      <div class="box-wrapper" *ngFor="let item of section?.data_images">
        <div class="content-box">
          <div class="{{item?.icon_class}}"></div>
          <div class="content">{{item?.text}}</div>
        </div>
      </div>
    </div>
    <div class="grey-divider"></div>
    <div class="ketto-shadow">
      <img data-src="/assets/images/medical-landing/ketto-shadow.png">
    </div>

    <!-- <div class="row sac-btn">
      <app-sac-button label="Start a Fundraiser" width="320px" height="40px" [redirectSac]="true"></app-sac-button>
    </div> -->
  </div>
</div>
